/**
 * RefundSlice Edit Tracking Reducers
 * 
 * Handles edit state management and validation.
 */

import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { RefundSliceState } from '../state';

/**
 * Mark as saved (clear edit state)
 */
export const markAsSaved: CaseReducer<RefundSliceState> = (state) => {
  state.isEdited = false;
  state.editedFields = [];
};

/**
 * Discard changes (reset edit state)
 */
export const discardChanges: CaseReducer<RefundSliceState> = (state) => {
  // This would need to be handled by reloading from API
  // For now, just reset the edited state
  state.isEdited = false;
  state.editedFields = [];
};

/**
 * Set a validation error for a field
 */
export const setValidationError: CaseReducer<
  RefundSliceState,
  PayloadAction<{ field: string; message: string }>
> = (state, action) => {
  state.validationErrors[action.payload.field] = action.payload.message;
};

/**
 * Clear a validation error for a field
 */
export const clearValidationError: CaseReducer<RefundSliceState, PayloadAction<string>> = (
  state,
  action
) => {
  delete state.validationErrors[action.payload];
};

/**
 * Clear all validation errors
 */
export const clearAllValidationErrors: CaseReducer<RefundSliceState> = (state) => {
  state.validationErrors = {};
};
